import React from 'react';
import { ActionIconButton } from '../ui/ActionButton';

/** Shared primitive for close, share and menu actions in the workout header. */
export function WorkoutChromeIconButton({
  label, danger, close, children, icon, className = '', ...props
}: Omit<React.ComponentProps<typeof ActionIconButton>, 'icon'> & {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  danger?: boolean;
  close?: boolean;
}) {
  return <ActionIconButton
    {...props}
    label={label}
    size="md"
    variant={danger ? 'danger' : 'neutral'}
    icon={icon ?? children}
    className={[
      'workout-detail-panel__header-btn',
      danger && 'workout-detail-panel__header-btn--danger',
      close && 'workout-detail-panel__header-btn--close',
      className,
    ].filter(Boolean).join(' ')}
  />;
}

